<template>
  <div v-title data-title="知识点">
    <main class="g-view-container">
      <!-- <swiper v-if="knowList.length" :options="swiperOption" @slide-change="swiperChange">
        <swiper-slide v-for="(item, index) in knowList" :key="item.knowledgeId">
          <h4 class="title">【考点 {{ index + 1 }}】{{ item.title }}</h4>
          <div class="body">
            <div class="sub-title">重点：{{ item.subTitle }}</div>
            <p class="content" v-html="item.content"></p>
          </div>
        </swiper-slide>
      </swiper> -->

      <swiper v-if="knowList.length" :options="swiperOption">
        <swiper-slide v-for="(item, index) in knowList" :key="item.knowledgeId">
          <h4 class="title">【考点 {{ index + 1 }}】{{ item.title }}</h4>
          <div class="body">
            <div class="sub-title">重点：{{ item.subTitle }}</div>
            <p class="content" v-html="item.content"></p>
          </div>
        </swiper-slide>
      </swiper>

      <div class="swiper-button">
        <div class="swiper-button-prev">上一个</div>
        <div class="swiper-button-next">下一个</div>
      </div>
    </main>
  </div>
</template>

<!-- <script>
// 获取图片元素
  // 监听图片点击事件
</script> -->

<script>
  export default {
    name: 'knowDetail',
    data() {
      return {
        courseId: this.$route.query.courseId,
        chapterNo: this.$route.query.chapterNo,
        knowList: [],
        swiperOption: {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      };
    },
    created() {
      this.getKnow();
    },
    methods: {
      getKnow() {
        this.showLoading();
        this.axios
          .get(
            `https://cbt.tibaitong.com/courseChapter/getChapterContent?courseId=${this.courseId}&chapterNo=${this.chapterNo}`,
          )
          .then((res) => {
            this.hideLoading();
            if (res.data.code === 200) {
              this.knowList = res.data.data || [];
            }
          });
      },

      // swiperChange() {
      //   const slideActive = document.querySelector('.swiper-slide-prev');
      //   console.log(slideActive);
      //   if (!slideActive) return
      //   const previewImage = slideActive.querySelector('img')
      //   console.log(previewImage);
      //   if (previewImage) {
      //     console.log('有');
      //     previewImage.addEventListener('click', () => {
      //       console.log(1);
      //       // 创建预览图片的div元素
      //       const previewDiv = document.createElement('div');
      //       previewDiv.style.position = 'fixed';
      //       previewDiv.style.top = 0;
      //       previewDiv.style.left = 0;
      //       previewDiv.style.width = '100%';
      //       previewDiv.style.height = '100%';
      //       previewDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
      //       previewDiv.style.display = 'flex';
      //       previewDiv.style.justifyContent = 'center';
      //       previewDiv.style.alignItems = 'center';

      //       // 创建预览图片元素，并设置其位置和宽高
      //       const previewImg = document.createElement('img');
      //       previewImg.src = this.src;
      //       previewImg.style.maxWidth = '90%';
      //       previewImg.style.maxHeight = '90%';
      //       previewImg.style.objectFit = 'contain';

      //       // 将预览图片元素添加到预览div中
      //       previewDiv.appendChild(previewImg);

      //       // 将预览div添加到文档中
      //       document.body.appendChild(previewDiv);

      //       // 监听预览图片的点击事件，当用户点击预览图片时，隐藏预览div
      //       previewImg.addEventListener('click', () => {
      //         previewDiv.style.display = 'none';
      //       });
      //     });
      //   } else {
      //     console.log('无');
      //   }
      // }
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.g-view-container {
  position: relative;
}

.swiper-container {
  height: calc(100% - 100px);

  .swiper-slide {
    height: 100%;
    padding: 0 15px;
    @include flex-between(column);

    .title {
      width: 100%;
      margin: 25px 0 15px 0;
      font-size: $font-size-l;
      color: $theme-color;
    }

    .body {
      flex: 1;
      width: 100%;
      padding: 20px;
      background-color: #fff;
      border-radius: 8px;
      overflow: scroll;
    }

    .sub-title {
      margin-bottom: 20px;
      color: #333;
      font-weight: bold;
    }

    .content {
      font-size: $font-size-l;
      line-height: 2;
    }
  }
}

.swiper-button {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 30px;
  @include flex-between();
  justify-content: space-around;

  .swiper-button-prev {
    position: static;
    width: 120px;
    height: 40px;
    font-size: $font-size-l;
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 4px;
    background: none;
    background-color: #fec24f;
  }

  .swiper-button-next {
    @extend .swiper-button-prev;
    background-color: $theme-color;
  }
}
</style>
